import { HttpResult } from './../models/API';
import { httpInject } from './_httpInject';
import fetchJsonp from 'fetch-jsonp';

export const genGetParams = (url: string, params: object = {}): string => {
    const qs = Object.entries(params).map(([k, v]) => `${k}=${v}`).join('&');
    let fixedUrl = url;
    if (qs) {
        fixedUrl += `?${qs}`;
    }
    return fixedUrl;
};

export const jsonGet = (url: string, params: object = {}) => {
    const urlWithParams = genGetParams(url, params);
    // FIXME: remove this after have real api
    const temp = httpInject(url) as HttpResult;
    if (temp) {
        return Promise.resolve(temp);
    }
    // @end
    return new Promise<HttpResult>((resolve, reject) => {
        fetch(urlWithParams).then(async (response): Promise<HttpResult> => {
            const { status } = response;
            return { status, body: await response.json() };
        }).then((jsonData) => {
            return (resolve(jsonData));
        }).catch((error) => {
            reject({ status: 500, body: { msg: error.toString() } });
        });
    });
};

export const jsonGetWithCredential = (url: string, params: object = {}) => {
    const urlWithParams = genGetParams(url, params);
    return new Promise<HttpResult>((resolve, reject) => {
        fetch(urlWithParams, {
            credentials: 'include',
        }).then(async (response): Promise<HttpResult> => {
            const { status } = response;
            return { status, body: await response.json() };
        }).then((jsonData) => {
            return (resolve(jsonData));
        }).catch((error) => {
            reject({ status: 500, body: { msg: error.toString() } });
        });
    });
};

export const jsonpGet = (url: string, params: object = {}) => {
    const urlWithParams = genGetParams(url, params);
    return new Promise<HttpResult>((resolve, reject) => {
        fetchJsonp(urlWithParams).then(async (response): Promise<HttpResult> => {
            const status = response.ok ? 200 : 500;
            return { status, body: await response.json() };
        }).then((jsonData) => {
            return (resolve(jsonData));
        }).catch((error) => {
            reject({ status: 500, body: { msg: error.toString() } });
        });
    });
};

export const jsonPost = (url: string, args: object = {}) => {
    return new Promise<HttpResult>((resolve, reject) => {
        fetch(url, {
            body: JSON.stringify(args),
            credentials: 'include',
            mode: 'cors',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            method: 'POST',
        }).then(async (response): Promise<HttpResult> => {
            const { status } = response;
            return { status, body: await response.json() };
        }).then((jsonData) => {
            resolve(jsonData);
        }).catch((error) => {
            reject({ status: 500, body: { msg: error.toString() } });
        });
    });
};



// WEBPACK FOOTER //
// ./src/utils/http.ts